<template>
    <b-modal
            body-class="p-0"
            cancel-disabled
            hide-footer
            id="imei-modal"
            ok-disabled
            title="">
        <div class="modal-body modal-body-lg pt-0">
            <h4 class="text-center">
              {{ $t('bp.ImeiModal.title') }}
            </h4>
        </div>
        <div class="modal-body modal-body-lg pt-0">
            <h3 class="title"></h3>
            <p>
              {{ $t('bp.ImeiModal.text.p1') }}
            </p>
            <ol>
                <li>
                    <strong>{{ $t('bp.ImeiModal.text.list.item1.p1') }}</strong> {{ $t('bp.ImeiModal.text.list.item1.p2') }} <pre class="d-inline">*#06#</pre> {{ $t('bp.ImeiModal.text.list.item1.p3') }}
                </li>
                <li>
                    <div>
                        <strong>{{ $t('bp.ImeiModal.text.list.item2.p1') }}</strong>{{ $t('bp.ImeiModal.text.list.item2.p2') }}<pre class="d-inline">{{ $t('bp.ImeiModal.text.list.item2.p3') }}</pre>.
                    </div>
                    <div>
                        <strong>{{ $t('bp.ImeiModal.text.list.item3.p1') }}</strong>{{ $t('bp.ImeiModal.text.list.item3.p2') }}<pre class="d-inline">{{ $t('bp.ImeiModal.text.list.item3.p3') }}</pre>.
                    </div>
                </li>
                <li>
                    <strong>{{ $t('bp.ImeiModal.text.list.item4.p1') }}</strong>{{ $t('bp.ImeiModal.text.list.item4.p2') }}
                </li>
            </ol>
        </div>
    </b-modal>
</template>

<script>
    export default {
    }
</script>

<style scoped>

</style>